let pro = {
    server_api: 'https://api.angel.ai/miniapp/v1/',
    server_url: 'https://api.angel.ai',
}
export default pro;
